export interface ReapplyRecipesVariationSelection {
	scalarFieldNames: string[];
	// key format: `${eventListName}::${eventId}` — preview supplies eventListName + eventId per change.
	eventIdChangeKeys: string[];
	assignmentOverrideEventIds: string[];
	regenerateTaskEvents: boolean;
}

export interface ReapplyRecipesJobSelection {
	enabled: boolean;
	variations: Record<string, ReapplyRecipesVariationSelection>;
	removedVariationIds: string[];
}

export interface ReapplyRecipesSelectionState {
	jobs: Record<string, ReapplyRecipesJobSelection>;
	cascadeChildJobs: Record<string, boolean>;
}

export interface ReapplyJobIdentity {
	categoryName: string;
	color: string;
	customerName: string;
	genus: string;
	jobCode: string;
	locationName: string;
	lotCode: string;
	productionPlanName: string;
	readyWeek: string;
	series: string;
}

export const eventIdChangeKey = (eventListName: string, eventId: string): string => `${eventListName}::${eventId}`;
